import {
    CMDPsNbsGift,
    CMDSpBetResult,
    CMDSpNbsBetResult,
} from '@/models/cmd/live';
import { RootState } from '@/store/store';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getHostByGameId } from '../host/slice';
import { getAnalytic } from './slice';
type betAnalyticThunkPayload = {
    command: CMDSpBetResult | CMDSpNbsBetResult;
    isNbs: boolean;
};
export const betAnalyticThunk = createAsyncThunk<void, betAnalyticThunkPayload>(
    'analytic/bet',
    async ({ command: bet, isNbs }, { getState }) => {
        try {
            const state = getState() as RootState;
            const analyticState = getAnalytic(state);
            const { apiUrl, ...otherState } = analyticState;
            if (apiUrl?.length > 0) {
                const hostState = getHostByGameId(state, bet.GameID);
                const data = {
                    recordId: crypto.randomUUID(),
                    hostId: hostState?.HostId,
                    gameId: bet.GameID,
                    gameType: hostState?.GameType,
                    betTime: +Date.now(),
                    totalBetAmount: bet.Bet.map(b => b.Base.betAmount).reduce(
                        (p, c) => p + c,
                        0
                    ),
                    betType: bet.Bet.map(v => v.Base.betType).toString(),
                    isAutoBet: isNbs,
                    ...otherState,
                };
                const response = await fetch(analyticState.apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(data),
                });
                console.log(response);
            }
        } catch (err) {
            console.warn('bet::analytic::thunk::err', err);
        }
    }
);

type giftAnalyticThunkPayload = {
    command: CMDPsNbsGift;
};

export const giftAnalyticThunk = createAsyncThunk<
    void,
    giftAnalyticThunkPayload
>('analytic/gift', async ({ command }, { getState }) => {
    try {
        const state = getState() as RootState;
        const analyticState = getAnalytic(state);
        const { apiUrl } = analyticState;
        if (apiUrl?.length > 0) {
            // Prepare payload for gift record creation
            const uuid = command.UUID;
            const hostId = command.HostID;
            const giftId = command.GiftID;

            // Create gift record
            await fetch(`${apiUrl}/gift`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ uuid, hostId, giftId }),
            });
        }
    } catch (err) {
        console.warn('gift::analytic::thunk::err', err);
    }
});

// Thunk to mark gift record as success
export const giftRecordSuccessThunk = createAsyncThunk<void, { uuid: string }>(
    'analytic/giftSuccess',
    async ({ uuid }, { getState }) => {
        try {
            const state = getState() as RootState;
            const analyticState = getAnalytic(state);
            const { apiUrl } = analyticState;
            if (apiUrl?.length > 0 && uuid) {
                await fetch(`${apiUrl}/gift/success/${uuid}`, {
                    method: 'PATCH',
                });
            }
        } catch (err) {
            console.warn('gift::analytic::success::thunk::err', err);
        }
    }
);

// Thunk to mark gift record as error
export const giftRecordErrorThunk = createAsyncThunk<void, { uuid: string }>(
    'analytic/giftError',
    async ({ uuid }, { getState }) => {
        try {
            const state = getState() as RootState;
            const analyticState = getAnalytic(state);
            const { apiUrl } = analyticState;
            if (apiUrl?.length > 0 && uuid) {
                await fetch(`${apiUrl}/gift/error/${uuid}`, {
                    method: 'PATCH',
                });
            }
        } catch (err) {
            console.warn('gift::analytic::error::thunk::err', err);
        }
    }
);
